import React, { useState } from "react";
import { t } from "../../Utils/translate";
import "./reassignDoc.css";

const DateSelection = ({
  selectedDate,
  selectedSlot,
  availableSlots,
  appointmentTimeRef,
  onDateChange,
  onSlotClick,
  today,
  onJustificationChange,
  justificationValue,
  justificationError
}) => {
  const [justification, setJustification] = useState("");

  const handleJustificationChange = (e) => {
    let value = e.target.value;

    // Prevent first character being a space
    if (value.length === 1 && value[0] === " ") return;

    setJustification(value);

    // Notify parent
    if (onJustificationChange) {
      onJustificationChange(value);
    }
  };

  const renderSelectDateComponent = () => (
    <div className="select-date-container">
      <div className="appointment-container">
        <div className="appointment-row">
          <label className="appointment-label">{t("AppointmentDate")}:</label>
          <input
            type="date"
            value={selectedDate}
            onChange={onDateChange}
            min={today}
            className="appointment-input"
          />
        </div>
      </div>

      <div className="occupied-container">
        <h2 className="occupied-title">{t("availableSlots")}:</h2>

        <div className="occupied-slots">
          {availableSlots.length === 0
            ? t("noSlots")
            : availableSlots.map((slot, index) => (
                <div
                  key={index}
                  className="slot-item cursor-pointer"
                  onClick={() => onSlotClick(slot)}
                >
                  {slot}
                </div>
              ))}
        </div>
        <div className="slot-divider-wrapper">
          <div className="slot-divider"></div>
        </div>
      </div>

      <div className="appointment-time-container">
        <div className="appointment-time-row" ref={appointmentTimeRef}>
          <label className="appointment-time-label">{t("AppointmentTime")}:</label>
          <div className="appointment-time-display text-l">
            {selectedSlot ? selectedSlot : "--:--"}
          </div>
        </div>
      </div>
    </div>
  );

  const renderJustificationInput = () => (
    <div>
      <label className="rr-body-head">{t("justificationForReassignment")}</label>
     <input
  type="text"
  className={`rs-justification ${justificationError ? 'border-red-500 focus:border-red-500 focus:ring-red-200' : 'border-gray-300'}`}
  placeholder={t("reasonForReassignment")}
  value={justificationValue}
  onChange={handleJustificationChange}
/>
{justificationError && (
  <div className="error-message text-red-500 text-sm mt-1">
    {justificationError}
  </div>
)}
<div className="character-counter text-right text-sm text-gray-500 mt-1">
  {justificationValue?.length || 0}/10 characters
</div>
    </div>
  );

  return (
    <>
      {renderSelectDateComponent()}
      {renderJustificationInput()}
    </>
  );
};

export default DateSelection;
